// Stripe invoice history - GET /v1/billing/invoices with cursor-based
// pagination (starting_after). The saga echoes the cursor back in the
// success payload so the panel knows whether to append or replace.
const action = "BILLING_INVOICES";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const CLEAR    = action + '_CLEAR';

export const fetchRequest = (payload)  => ({ type: REQUEST,  payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error)    => ({ type: FAILURE,  payload: error });
export const clearState   = ()         => ({ type: CLEAR });
